import { openModal } from '../../core/modal/open-modal';
import { RenameDialog } from '../../components/dialogs/rename.dialog';
import { Stage } from '../../app/entities/stage';
import { catchError } from '../../core/catch-error';

/**
 * The one "create stage" entry point. Opened from the project overview's header action
 * (`project-root.screen.tsx`) and from the calendar's own header — previously the overview
 * screen held this inline, and the calendar would have been a second copy of it.
 *
 * `RenameDialog` is the generic name-a-thing dialog; `openModal` supplies its `onCancel`.
 */
export const openCreateStageModal = (projectId: string): void => {
  openModal(RenameDialog, {
    defaultName: '',
    title: 'Create stage',
    label: 'Stage name',
    placeholder: 'Enter stage name',
    onSubmit: async (name: string) => {
      try {
        await Stage.create(projectId, name);
      } catch (e) {
        catchError(e);
      }
    },
  });
};
